import { render, staticRenderFns } from "./MailProcessingTemplateCreate.vue?vue&type=template&id=7d15c011"
import script from "./MailProcessingTemplateCreate.vue?vue&type=script&lang=js"
export * from "./MailProcessingTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports